'use client';

import type {
  ValidateAccountServiceRequest,
  ValidateAccountServiceResponse,
} from '@musinsa/services-curator';
import { validateAccountService } from '@musinsa/services-curator';
import { useMutation } from '@tanstack/react-query';

interface UseAccountValidationOptions {
  onSuccess?: (data: ValidateAccountServiceResponse) => void;
  onError?: (error: Error) => void;
}

export const useAccountValidation = (options?: UseAccountValidationOptions) =>
  useMutation({
    mutationFn: (params: ValidateAccountServiceRequest) => validateAccountService(params),
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });
